/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentUrl } from '../../models/attachment-url';

export interface GetAttachmentUrl$Params {
  entityId: string;
  attachmentId: string;
  entityClass: 'BulkPrintRequest' | 'FormQualityEntry' | 'FormRiskEntry' | 'FormSnapshotRequest' | 'FormCustom';
}

export function getAttachmentUrl(
  http: HttpClient,
  rootUrl: string,
  params: GetAttachmentUrl$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<AttachmentUrl>> {
  const rb = new RequestBuilder(rootUrl, getAttachmentUrl.PATH, 'get');
  if (params) {
    rb.path('entityId', params.entityId, {});
    rb.path('attachmentId', params.attachmentId, {});
    rb.path('entityClass', params.entityClass, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AttachmentUrl>;
    })
  );
}

getAttachmentUrl.PATH = '/attachments/{entityClass}/{entityId}/{attachmentId}';
